// extracted by mini-css-extract-plugin
export var description = "SessionWarningDialog-module--description--7d74a";
export var error = "SessionWarningDialog-module--error--bc7d2";
export var errorIcon = "SessionWarningDialog-module--errorIcon--a8df7";
export var iconContainer = "SessionWarningDialog-module--iconContainer--17092";
export var idleHint = "SessionWarningDialog-module--idleHint--6f043";
export var logo = "SessionWarningDialog-module--logo--ef20f";
export var progressBar = "SessionWarningDialog-module--progressBar--a88f6";
export var progressContainer = "SessionWarningDialog-module--progressContainer--fa4c5";
export var sessionWarningContent = "SessionWarningDialog-module--sessionWarningContent--f2831";
export var sessionWarningDialog = "SessionWarningDialog-module--sessionWarningDialog--485c8";
export var sessionWarningLogo = "SessionWarningDialog-module--sessionWarningLogo--6621f";
export var typeAbsolute = "SessionWarningDialog-module--type-absolute--ce427";
export var typeIdle = "SessionWarningDialog-module--type-idle--71c22";
export var typeToken = "SessionWarningDialog-module--type-token--7a718";
export var urgent = "SessionWarningDialog-module--urgent--c0e88";
export var urgentProgress = "SessionWarningDialog-module--urgentProgress--b4827";
export var warning = "SessionWarningDialog-module--warning--d3642";
export var warningHeader = "SessionWarningDialog-module--warningHeader--2c84d";
export var warningIcon = "SessionWarningDialog-module--warningIcon--16bb6";
export var warningTitle = "SessionWarningDialog-module--warningTitle--447e1";